import React from "react"
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import TableOrderDetail from "./TableOrderDetail"
import Select from "react-select"
import TableFilter from "./TableFilter"

const ModalDetailOrder = ({ isModal, setIsModal }) => {
  const toggle = () => setIsModal(!isModal)

  return (
    <Modal isOpen={isModal} toggle={toggle} centered className="modal-xl">
      <ModalHeader toggle={toggle}>受注詳細</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="7">
            <FormGroup row>
              <Label sm="2">顧客名</Label>
              <Col sm="4">
                <Input type="text" />
              </Col>
              <Col
                sm="3"
                className="d-flex align-items-center justify-content-start gap-3"
              >
                <Input type="checkbox" />
                <Label className="mb-0">ゲスト</Label>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm="2">受注日</Label>
              <Col sm="4">
                <Input type="text" />
              </Col>
            </FormGroup>
            <Row>
              <Col sm="12">
                <TableOrderDetail
                  content={[
                    {
                      rtw_product_number: "",
                      product_name: "",
                      unit_price: "",
                      number: "",
                      discount: "",
                      total_amount: "",
                    },
                  ]}
                />
              </Col>
            </Row>
          </Col>
          <Col sm="5">
            <FormGroup row>
              <Label sm="2">日付</Label>
              <Col sm="6">
                <Input type="date" />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm="2">入金方法</Label>
              <Col sm="6">
                <Select />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm="2">代金回収</Label>
              <Col sm="6">
                <Input type="text" />
              </Col>
              <Col
                sm="4"
                className="d-flex align-items-start justify-content-end"
              >
                <Button color="primary" className="w-100">
                  登録
                </Button>
              </Col>
            </FormGroup>
            <Row>
              <Col sm="12">
                <TableFilter
                  content={[
                    {
                      date: "2022/7/21",
                      payment_method: "現金振込",
                      amount_of_money: "60000",
                    },
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ModalDetailOrder
